export enum AssetClassEnum {
	US_EQUITY = 'us_equity',
	US_OPTION = 'us_option',
}
